import SearchField from "./SearchField";
import {
  VMenu,
  VBtn,
  VList,
  VListItem,
  VListItemTitle,
  VDataTable,
  VChip,
} from "vuetify/lib";
import SpuDetail from "./SpuDetail";
import CreateSkuModal from "./createSkuModal";
import { changeSpuStatus, querySpuList } from "../service";
import { devStatus, flowStatus, SPU_TYPE } from "../constants";

export default {
  data() {
    const t = new Date().getTime();
    return {
      total: 200,
      loading: true,
      dataSource: [],
      options: {},
      expanded: [],
      tableHeaders: [
        {
          text: "SPU编号",
          align: "center",
          value: "uid",
          width: 120,
        },
        {
          text: "SPU",
          align: "center",
          value: "spu_name",
          width: 120,
        },
        {
          text: "PF",
          align: "center",
          value: "product_family",
          width: 120,
        },
        {
          text: "BU",
          align: "center",
          value: "business_unit",
          width: 120,
        },
        {
          text: "SPU等级",
          align: "center",
          value: "company_level",
          width: 120,
        },
        {
          text: "类型",
          align: "center",
          value: "type",
          width: 120,
        },
        {
          text: "申请人",
          align: "center",
          value: "customer_name",
          width: 120,
        },
        {
          text: "研发团队",
          align: "center",
          value: "research_team",
          width: 120,
        },
        {
          text: "流程状态",
          align: "center",
          value: "status",
          width: 120,
        },
        {
          text: "操作",
          align: "center",
          width: 120,
          value: "actions",
        },
      ],
      rt: t,
    };
  },
  computed: {
    canEditSpu() {
      const current_hash = this.$store.state.hash_authority || {};
      return current_hash["edit_spu_btn"];
    },
    canEditStage() {
      const current_hash = this.$store.state.hash_authority || {};
      return current_hash["edit_spu_stage"];
    },
    cur_customer() {
      return this.$store.state.cur_customer;
    },
  },

  watch: {
    options: {
      handler(e) {
        this.getData(e);
      },
      deep: true,
    },
  },

  methods: {
    async getData(pagination) {
      this.loading = true;
      const search = this.$refs.searchField.search;
      const filteredSearch = {};
      Object.keys(search).forEach((item) => {
        if (search[item] || search[item] === false) {
          filteredSearch[item] = search[item];
        }
      });
      const params = {
        page: pagination.page || 1,
        per_page: pagination.itemsPerPage || 20,
        ...filteredSearch,
      };
      querySpuList(params).then((res) => {
        this.dataSource = res.results;
        this.total = res.total_count;
        this.loading = false;
      });
    },
    edit(item) {
      this.$refs.edit.edit(item);
    },
    changeStatus(id, status) {
      return changeSpuStatus({ id: id, status: status });
    },
    refresh() {
      this.getData(this.options);
    },
  },
  render() {
    return (
      <div>
        <SearchField
          ref="searchField"
          on-add={() => {
            this.edit({});
          }}
          on-search={() => {
            this.options.page = 1;
            this.getData({ ...this.options, page: 1 });
            this.rt = new Date().getTime();
          }}
        ></SearchField>
        <VDataTable
          show-expand
          expand={this.expanded}
          loading={this.loading}
          page={this.page}
          options={this.options}
          server-items-length={this.total}
          on={{
            ["update:page"]: (val) => {
              this.page = val;
            },
            ["update:options"]: (val) => {
              this.options = val;
            },
            ["update:expanded"]: (val) => {
              this.expanded = val;
            },
          }}
          items={this.dataSource}
          headers={this.tableHeaders}
          scopedSlots={{
            ["item.uid"]: ({ item: row }) => {
              return <span>{row.uid + '' + row.tail_num}</span>;
            },
            ["item.company_level"]: ({ item: row }) => {
              return <span>{row.company_level ? "公司级" : "非公司级"}</span>;
            },
            ["item.type"]: ({ item: row }) => {
              const select = SPU_TYPE.find(item => item.value === row.type)
              // return <span>{select =  row.type === 1 ? "虚拟" : "实体"}</span>;
              return <span>{select ? select.label : '-'}</span>;
            },
            ["item.status"]: ({ item: row }) => {
              return (
                <span>
                  {flowStatus.find((f) => f.value === row.status).label || "-"}
                  {row.status === flowStatus[0].value &&
                  devStatus.some((f) => f.value === row.sub_status)
                    ? "-" +
                      devStatus.find((f) => f.value === row.sub_status).label
                    : ""}
                  {row.delayed && (
                    <VChip color="red" text-color="white" x-small>
                      Delay
                    </VChip>
                  )}
                </span>
              );
            },
            ["item.actions"]: ({ item: row }) => {
              return (
                <div>
                  {(this.canEditSpu ||
                    this.cur_customer.id === row.customer_id ||
                    (row.status === "closed" &&
                      (this.canEditStage ||
                        this.cur_customer.id === row.customer_id)) ||
                    (row.status === "operating" &&
                      (this.canEditStage ||
                        this.cur_customer.id === row.customer_id))) && (
                    <VMenu
                      top
                      close-on-click={true}
                      scopedSlots={{
                        activator: ({ on, attrs }) => (
                          <VBtn {...attrs} on={on} color="primary">
                            操作
                          </VBtn>
                        ),
                      }}
                    >
                      <VList>
                        {(this.canEditSpu ||
                          this.cur_customer.id === row.customer_id) && (
                          <VListItem
                            onclick={() => {
                              this.edit(row);
                            }}
                          >
                            <VListItemTitle>编辑</VListItemTitle>
                          </VListItem>
                        )}
                        {row.status === "closed" &&
                          (this.canEditStage ||
                            this.cur_customer.id === row.customer_id) && (
                            <VListItem
                              onClick={() => {
                                this.changeStatus(row.id, "operating").then(
                                  () => {
                                    this.refresh();
                                  }
                                );
                              }}
                            >
                              <VListItemTitle>启用</VListItemTitle>
                            </VListItem>
                          )}
                        {row.status === "operating" &&
                          (this.canEditStage ||
                            this.cur_customer.id === row.customer_id) && (
                            <VListItem
                              onClick={() => {
                                this.changeStatus(row.id, "closed").then(() => {
                                  this.refresh();
                                });
                              }}
                            >
                              <VListItemTitle>停用</VListItemTitle>
                            </VListItem>
                          )}
                      </VList>
                    </VMenu>
                  )}
                </div>
              );
            },
            ["expanded-item"]: ({ headers, item }) => {
              return (
                <td colspan={headers.length} style="padding: 1px;">
                  <SpuDetail
                    spuId={item.id}
                    on={{
                      refresh: () => {
                        this.refresh();
                      },
                    }}
                    rt={this.rt}
                  ></SpuDetail>
                </td>
              );
            },
          }}
        ></VDataTable>
        <CreateSkuModal
          ref="edit"
          on={{
            success: () => {
              this.refresh();
              this.rt = new Date().getTime();
            },
          }}
        />
      </div>
    );
  },
};
